import { MapPin, Clock, Phone, Navigation } from "lucide-react";

const hours = [
  ["Monday – Saturday", "9:00 AM – 7:00 PM"],
  ["Sunday", "Closed"],
];

export const VisitShop = () => (
  <section id="visit" data-testid="visit-section" className="py-24 md:py-32 bg-[#0A0A0A]">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-[#FF4500]" />
            <span className="text-sm uppercase tracking-[0.3em] text-[#FF4500] font-semibold">Location & Hours</span>
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight uppercase text-white">
            Visit the Shop
          </h2>
          <p className="mt-4 text-base md:text-lg text-neutral-400 max-w-lg">
            Roll in for a walkaround, a consultation, or just to see the builds in progress. No appointment needed to talk cars.
          </p>

          <div className="mt-10 space-y-6">
            <div className="flex items-start gap-4" data-testid="shop-address">
              <div className="w-11 h-11 shrink-0 flex items-center justify-center border border-[#FF4500] text-[#FF4500]">
                <MapPin size={20} />
              </div>
              <div>
                <p className="text-xs uppercase tracking-widest text-neutral-500 mb-1">Address</p>
                <p className="font-heading text-xl font-bold uppercase text-white">318 Logan Avenue</p>
              </div>
            </div>
            <div className="flex items-start gap-4" data-testid="shop-phone">
              <div className="w-11 h-11 shrink-0 flex items-center justify-center border border-[#FF4500] text-[#FF4500]">
                <Phone size={20} />
              </div>
              <div>
                <p className="text-xs uppercase tracking-widest text-neutral-500 mb-1">Call Us</p>
                <a href="tel:2046196003" className="font-heading text-xl font-bold uppercase text-white hover:text-[#FF4500] transition-colors">
                  204-619-6003
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4" data-testid="shop-hours">
              <div className="w-11 h-11 shrink-0 flex items-center justify-center border border-[#FF4500] text-[#FF4500]">
                <Clock size={20} />
              </div>
              <div className="flex-1">
                <p className="text-xs uppercase tracking-widest text-neutral-500 mb-2">Hours</p>
                {hours.map(([day, time]) => (
                  <div key={day} className="flex justify-between gap-8 border-b border-[#262626] py-2 max-w-sm">
                    <span className="text-sm text-neutral-300">{day}</span>
                    <span className={`text-sm font-semibold ${time === "Closed" ? "text-neutral-600" : "text-white"}`}>{time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <a
            href="https://www.google.com/maps/search/?api=1&query=318+Logan+Avenue"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="get-directions-btn"
            className="mt-10 inline-flex items-center gap-3 bg-transparent text-white font-bold uppercase tracking-wider py-4 px-8 border border-neutral-700 hover:border-[#FF4500] hover:text-[#FF4500] transition-all duration-300"
          >
            <Navigation size={18} />
            Get Directions
          </a>
        </div>

        <div
          data-testid="map-placeholder"
          className="relative h-[420px] lg:h-[540px] bg-[#141414] border border-[#262626] overflow-hidden"
        >
          <div
            className="absolute inset-0 opacity-30 grayscale bg-cover bg-center"
            style={{
              backgroundImage:
                "url(https://images.unsplash.com/photo-1524661135-423995f22d0b?w=1200&q=60)",
            }}
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
            <div className="relative">
              <span className="absolute inset-0 animate-ping bg-[#FF4500]/30" style={{ borderRadius: "50%" }} />
              <div className="relative w-16 h-16 flex items-center justify-center bg-[#FF4500] text-white">
                <MapPin size={28} />
              </div>
            </div>
            <p className="font-heading text-2xl font-bold uppercase text-white tracking-tight">318 Logan Avenue</p>
            <p className="text-sm uppercase tracking-widest text-neutral-500">Interactive map coming soon</p>
          </div>
        </div>
      </div>
    </div>
  </section>
);
